import User from '../../../resources/scripts/features/user-manager';

class BrixProductFiles {
  static init(...parameters) {
    return new BrixProductFiles(...parameters);
  }

  constructor(block) {
    if (block) {
      const infoWrapperLinks = document.querySelectorAll(
        `#${block.id} .info-wrapper`,
      );
      const downloadLinks = document.querySelectorAll(
        `#${block.id} .download-link`,
      );

      if (infoWrapperLinks) {
        [...infoWrapperLinks].forEach((infoWrapperLink) => {
          if (infoWrapperLink.nodeName === 'A') {
            infoWrapperLink.addEventListener('click', (e) => {
              this.addFileViewEvent(e);
            });
          }
        });
      }

      if (downloadLinks) {
        [...downloadLinks].forEach((downloadLink) => {
          if (downloadLink.nodeName === 'A') {
            downloadLink.addEventListener('click', (e) => {
              this.addFileDownloadEvent(e);
            });
          }
        });
      }
    }
  }

  addFileViewEvent(e) {
    const link = e.target.closest('.info-wrapper');
    if (link) {
      const data = {
        event: 'view',
        filename: link.dataset.filename,
        file_category: link.dataset.category,
        file_description: link.dataset.description,
        file_url: link.dataset.file_url,
        page_url: window.location.href,
      };

      if (data.filename) {
        User.sendFileEvent(data);
      }
    }
  }

  addFileDownloadEvent(e) {
    const link = e.target.closest('.download-link');
    if (link) {
      const data = {
        event: 'download',
        filename: link.dataset.filename,
        file_category: link.dataset.category,
        file_description: link.dataset.description,
        file_url: link.dataset.file_url,
        page_url: window.location.href,
      };

      if (data.filename) {
        User.sendFileEvent(data);
      }
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-product-files', BrixProductFiles.init);
}
